var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfContrast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3333334,0.666666667 L19.3333334,5.66666667 L19.333,9.49966667 L21,9.5 C21.5522847,9.5 22,9.94771525 22,10.5 L22,19.5 C22,20.0522847 21.5522847,20.5 21,20.5 L1,20.5 C0.44771525,20.5 6.76353751e-17,20.0522847 0,19.5 L0,10.5 C-6.76353751e-17,9.94771525 0.44771525,9.5 1,9.5 L2.666,9.49966667 L2.66666671,0.666666667 L14.3333334,0.666666667 Z M5.601,11.763 L3.585,11.763 L3.585,18 L5.061,18 L5.061,15.921 L5.736,15.921 C7.176,15.921 8.202,15.246 8.202,13.797 C8.202,12.429 7.212,11.763 5.601,11.763 Z M10.749,11.763 L9.012,11.763 L9.012,18 L10.884,18 C12.477,18 13.989,17.361 13.989,14.85 C13.989,12.276 12.414,11.763 10.749,11.763 Z M18.588,11.763 L14.871,11.763 L14.871,18 L16.347,18 L16.347,15.525 L18.165,15.525 L18.165,14.472 L16.347,14.472 L16.347,12.816 L18.435,12.816 L18.588,11.763 Z M10.956,12.834 C11.82,12.834 12.459,13.176 12.459,14.85 C12.459,16.506 11.865,16.929 10.974,16.929 L10.488,16.929 L10.488,12.834 L10.956,12.834 Z M5.583,12.816 C6.312,12.816 6.681,13.131 6.681,13.797 C6.681,14.58 6.276,14.859 5.61,14.859 L5.061,14.859 L5.061,12.816 L5.583,12.816 Z M12.6666667,2.33333333 L4.33333338,2.33333333 L4.333,9.49966667 L17.666,9.49966667 L17.6666667,7.33333333 L12.6666667,7.33333333 L12.6666667,2.33333333 Z M14.3333334,3.025 L14.3333334,5.66666667 L16.975,5.66666667 L14.3333334,3.025 Z",
    id: "Combined-Shape",
    fill: "#38e5e2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfContrast);
export default __webpack_public_path__ + "static/media/pdf-contrast.2b1437259024ed817fe50210976d20e3.svg";
export { ForwardRef as ReactComponent };